import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CreditCardInput from 'Components/forms/credit-card-input/CreditCardInput.jsx';
import CurrencyRangeInput from 'Components/forms/currency-range-input/CurrencyRangeInput.jsx';
import DualDateInput from 'Components/forms/DualDateInput';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import MultiSelectInput from 'Components/forms/multiselect-input/MultiSelectInput.jsx';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import YearMonthPicker from 'Components/forms/year-month-input/YearMonthPicker.jsx';
import moment from 'moment';

import './GDFilterElement.scss';
import SingleCalendar from '../../SingleCalendar/SingleCalendar';
import SingleDateInput from '../../forms/SingleDateInput/SingleDateInput';

const GDFilterElement = ({
  currentValues,
  dateFormat,
  extraClass,
  filter,
  onChange,
  onRangeChange,
  onSingleDateChange,
  translations,
  handleDualDates,
  handleMonthChange,
  handleSelection,
  handleSingleSelection,
  id,
}) => {
  const wrapperClass = classnames('gd-filter-element', {
    [extraClass]: extraClass,
  });
  let inputComponent;

  switch (filter.filterType) {
    case 'SELECT': {
      const inputValues = filter.filterValues.map((obj) => {
        return Object.assign({},
          { id: obj.id },
          { value: obj.value },
          { text: obj.valueLabel },
          { desc: obj.desc },
          { filterValueGroupId: obj.filterValueGroupId },
        );
      });

      const selectedFilterValue = (currentValues &&
        currentValues.v1 &&
        currentValues.v1.length)
        ? filter.filterValues.find((fVal) => {
          return fVal.value === currentValues.v1;
        })
        : null;

      const selectedItem = (selectedFilterValue)
        ? { value: selectedFilterValue.value, text: selectedFilterValue.valueLabel }
        : null;

      const choosePrompt = `${translations.select} ${filter.name}`;

      inputComponent = (
        <SelectInput
          name={filter.id}
          key={filter.id}
          dataList={inputValues}
          promptText={choosePrompt}
          wrapperClass="select-menu__form"
          label={filter.name}
          handleSelection={handleSingleSelection}
          selectedItem={selectedItem}
          id={`${id}_selectInput_${filter.reportFilterId}`}
        />
      );
      break;
    }

    case 'MULTISELECT': {
      const inputValues = filter.filterValues.map((obj) => {
        return Object.assign({},
          { id: obj.id },
          { value: obj.value },
          { text: obj.valueLabel },
          { desc: obj.desc },
          { filterValueGroupId: obj.filterValueGroupId },
        );
      });

      const selectedItems = [];
      if (currentValues && currentValues.v1 && currentValues.v1.length) {
        currentValues.v1.forEach(((element) => {
          const selectedElement = filter.filterValues.find((data) => {
            return element === data.value;
          });
          selectedItems.push({ value: selectedElement.value, text: selectedElement.valueLabel });
        }));
      }


      const choosePrompt = `${translations.select} ${filter.name}`;

      inputComponent = (
        <MultiSelectInput
          // @todo handleSelection
          name={filter.id}
          key={filter.id}
          dataList={inputValues}
          promptText={choosePrompt}
          wrapperClass="select-menu__form"
          label={filter.name}
          handleSelection={handleSelection}
          selectedItem={selectedItems}
        />
      );
      break;
    }
    case 'CURRENCY': {
      let lowVal = currentValues.v1 ? (Math.round(currentValues.v1 * 100) / 100).toFixed(2) : currentValues.v1;
      let highVal = currentValues.v2 ? (Math.round(currentValues.v2 * 100) / 100).toFixed(2) : currentValues.v2;
      inputComponent = (
        <CurrencyRangeInput
          id={filter.reportFilterId}
          key={filter.reportFilterId}
          filterLow={currentValues.v1}
          filterHigh={currentValues.v2}
          onChange={onRangeChange}
          title={filter.name}
          separatorText={translations.to}
        />
      );
      break;
    }
    case 'CC_NUMBER': {
      // @todo refactor handling credit card filter change events
      inputComponent = (
        <CreditCardInput
          id={filter.reportFilterId}
          key={filter.reportFilterId}
          label={filter.name}
          onSelectChange={null}
          onChange={onRangeChange}
          v1={currentValues.v1}
          v2={currentValues.v2}
        />
      );
      break;
    }
    case 'DATE': {
      let fromDate = currentValues.v1;
      let endDate = currentValues.v2;

      let defaultSelect = false;
      let isDefaultDateSelected = (filter.id === 'transactionDate') ? true : false;
      const yesterDay = moment().subtract(1, 'days');
      const newDate = moment(yesterDay).subtract(3, 'months');
      const lastSevenDays = moment().subtract(7, 'days');
      if (filter.id === 'transactionDate' && (fromDate == undefined || fromDate == null)) {
        fromDate = id.includes('UnmatchedImages') ? moment(lastSevenDays).format(dateFormat) : moment(newDate).format(dateFormat);
        endDate = moment(yesterDay).format(dateFormat);
        defaultSelect = true;
        let dualValues = {
          startDate: fromDate,
          endDate: endDate
        }
        handleDualDates(filter.id, dualValues);
      }
      inputComponent = (
        <DualDateInput
          id={filter.id}
          key={filter.id}
          onApply={handleDualDates}
          title={filter.name}
          startDate={fromDate}
          endDate={endDate}
          dateFormat={dateFormat}
          translations={translations.dates}
          defaultSelect={defaultSelect}
          isDefaultDateSelected={isDefaultDateSelected}
        />
      );
      break;
    }
    case 'SINGLE_DATE': {
      const singleDate = currentValues.v1;
      inputComponent = (
        <SingleDateInput
          id={filter.reportFilterId}
          name={filter.reportFilterId}
          onApply={onSingleDateChange}
          title={filter.name}
          singleDate={singleDate}
          minDate={moment().subtract(10, 'years')}
          dateFormat={dateFormat}
        />
      );
      break;
    }
    case 'MONTH_CALENDAR': {
      inputComponent = (
        <YearMonthPicker
          id={filter.reportFilterId}
          key={filter.reportFilterId}
          currentValues={currentValues}
          handleMonthChange={handleMonthChange}
          title={filter.name}
        />
      );
      break;
    }
    case 'STRING':
    default: {
      inputComponent = (
        <TextInput
          key={filter.reportFilterId}
          name={filter.reportFilterId}
          label={filter.name}
          type="text"
          onChange={onChange}
          placeholder=""
          value={currentValues.v1}
          extraStyle={{ fontSize: 12, fontWeight: 500 }}
        />
      );
    }
  }

  return (
    <div className={wrapperClass}>
      {inputComponent}
    </div>
  );
};

GDFilterElement.propTypes = {
  currentValues: PropTypes.object,
  dateFormat: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  translations: PropTypes.object,
  handleDualDates: PropTypes.func.isRequired,
  handleMonthChange: PropTypes.func.isRequired,
  handleSelection: PropTypes.func,
  handleSingleSelection: PropTypes.func,
  id: PropTypes.string,
};

GDFilterElement.defaultProps = {
  currentValues: {},
  extraClass: '',
  translations: {
    select: 'Select',
    to: 'To',
  },
  id: '',
  handleSelection: () => { },
  handleSingleSelection: () => { },
};

export default GDFilterElement;
